export { default as rChangePassword } from './changePassword';
export { default as rDeleteAccount } from './deleteAccount';
export { default as rUserSetting } from './userSetting';
export { default as rCheckNewPasswordToken } from './checkNewPasswordToken';
